import { useState, useEffect } from 'react';
/**
 * A React hook to manage the local window object
 *
 * @returns the local window object
 */
export const useWindow = () => {
    const [localWindow, setLocalWindow] = useState({});
    useEffect(() => {
        setLocalWindow(window);
        return () => {
            setLocalWindow({});
        };
    }, []);
    return localWindow;
};
